// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_2-HR9BLbygzrGgg80blzIB"};